export const EXIT_MODAL = {
  title: 'Are you sure you want to leave?',
  content: 'If so, we may need to contact you and follow up.',
};
